import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import React, { memo } from "react";

interface INodeSkeletonProps {
    /** Number of skeleton rows to show */
    rows?: number;
    /** "list" shows rows with a small chip + text; "detail" shows label + value pairs */
    variant?: "list" | "detail";
}

function NodeSkeleton({ rows = 3, variant = "list" }: INodeSkeletonProps) {
    return (
        <Stack spacing={0.75} sx={{ mt: 0.5 }}>
            {Array.from({ length: rows }, (_, i) =>
                variant === "list" ? (
                    <Stack key={i} direction="row" alignItems="center" spacing={0.75}>
                        <Skeleton variant="rounded" width={28} height={16} />
                        <Skeleton variant="text" width={`${65 - i * 10}%`} height={16} />
                    </Stack>
                ) : (
                    <Stack key={i} direction="row" justifyContent="space-between" alignItems="center">
                        <Skeleton variant="text" width={60} height={14} />
                        <Skeleton variant="text" width={40} height={14} />
                    </Stack>
                ),
            )}
        </Stack>
    );
}

export default memo(NodeSkeleton);
